import {createContext} from "react";
import {CombinedDataContext} from "../../hooks/identification/useCombinedData";
import {Phone} from "../../api-client";
const defaultCombinedData: CombinedDataContext = {
  // PersonalDataContext default values
  firstName: "",
  setFirstName: () => {},
  middleName: "",
  setMiddleName: () => {},
  lastName: "",
  setLastName: () => {},
  inn: "",
  setInn: () => {},
  email: "",
  setEmail: () => {},
  snils: "",
  setSnils: () => {},
  phone: new Phone('+7', ''),
  setPhone: () => {},

  // PassportDataContext default values
  passportSeries: "",
  setPassportSeries: () => {},
  passportNumber: "",
  setPassportNumber: () => {},
  passportIssuedDate: null,
  setPassportIssuedDate: () => {},
  passportIssuedBy: "",
  setPassportIssuedBy: () => {},
  passportDepartmentCode: "",
  setPassportDepartmentCode: () => {},
  citizenship: "",
  setCitizenship: () => {},
  firstPassportScans: [],
  setFirstPassportScans: () => {},
  secondPassportScans: [],
  setSecondPassportScans: () => {},
  thirdPassportScans: [],
  setThirdPassportScans: () => {},
  registrationAddress: "",
  setRegistrationAddress: () => {},
  birthplace: "",
  setBirthplace: () => {},
  birthday: null,
  setBirthday: () => {},

  // LegalEntityDataContext default values
  jobPosition: "",
  setJobPosition: () => {},
  innLegalEntity: "",
  setInnLegalEntity: () => {},
  companyName: "",
  setCompanyName: () => {},
  companyKpp: "",
  setCompanyKpp: () => {},
  companyAddress: "",
  setCompanyAddress: () => {},

  // PersonOgrnipDataContext default values
  ogrnip: "",
  setOgrnip: () => {},
};

const IdentificationContext = createContext(defaultCombinedData);

export default IdentificationContext;